import moment from "moment";
import { textLengths } from "../../../../redux/Types";

export const ValidateNews = (data) => {
    let errors = {}

    if (data && data.news) {
        data = data.news;
        if (!data.title) {
            errors.title = "Title should not be empty";
        } else if (data.title && data.title.length > textLengths.TEXT) {
            errors.title = "Sorry, the title you entered is too long. Please try a shorter title";
        }

        if (!data.message) {
            errors.message = "Message should not be empty";
        } else if (data.message && data.message.length > textLengths.LONGTEXT) {
            errors.message = "Sorry, the message you entered is too long. Please try a shorter message";
        }

        if(!data.visibility){
            errors.visibility = "Visibility should not be empty";
        }

        if(!data.startDate){
            errors.startDate = "Start Date should not be empty";
        }

        if(!data.expirationDate){
            errors.expirationDate = "Expires should not be empty";
        }

        if (data.startDate && data.expirationDate) {
            const start = moment(data.startDate);
            const end = moment(data.expirationDate);
            if (end.isSameOrBefore(start)) {
                errors.expirationDate = "Expires must be after Start Date";
            }
        }

    }


    if (Object.entries(errors).length === 0) {
        return null;
    } else {
        return errors;
    }
}